import { IKnmSupervisionType } from 'APIPackage/CatalogsModule/interfaces/IKnmSupervisionType';

import { ISupervisionTypeSelectOption } from '../hooks/useKnmSupervisionTypes';

export function createSupervisionTypesSelectOption(type: IKnmSupervisionType): ISupervisionTypeSelectOption {
  return {
    ...type,
    label: type.name,
    value: type.id,
  };
}
